import { Stack, styled } from "@mui/material";

export const StyledFileContext = styled("li")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  listStyle: "none",
  width: "fit-content",
  maxWidth: "14rem",
  height: "2rem",
  fontSize: "0.875rem",
  padding: "0.5rem",
  backgroundColor: theme.customColors.backgroundSecondary,
  color: theme.customColors.textInput,
  border: `1px solid  ${theme.customColors.border}`,
  borderRadius: "0.5rem",
  overflow: "hidden"
}));
export const StyledFileName = styled("span")(() => ({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}));

export const StyledListFiles = styled(Stack)(() => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "1rem"
}));
